import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useT } from "../../contexts/LanguageContext";
import { Cookie } from "@phosphor-icons/react";
import { enableTracking, disableTracking } from "../../lib/analytics";

const COOKIE_STORAGE_KEY = "pmpintel_cookie_consent_v1";

export default function CookieBanner() {
  const { t } = useT();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(COOKIE_STORAGE_KEY);
      if (!stored) setVisible(true);
    } catch {
      // localStorage unavailable (Safari private mode etc.) — show anyway
      setVisible(true);
    }
  }, []);

  const persist = (choice) => {
    try {
      localStorage.setItem(COOKIE_STORAGE_KEY, JSON.stringify({ choice, ts: new Date().toISOString() }));
    } catch { /* noop */ }
    setVisible(false);
    if (typeof window !== "undefined") {
      window.__cookieConsent = choice;
    }
    if (choice === "all") {
      enableTracking();
      // Soft-trigger Crisp by reloading the loader if it wasn't loaded yet
      if (typeof window !== "undefined" && window.location && process.env.REACT_APP_CRISP_WEBSITE_ID && !window.$crisp) {
        window.location.reload();
      }
    } else {
      disableTracking();
    }
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-3 left-3 right-3 sm:right-6 sm:left-auto sm:bottom-6 sm:max-w-md z-50 animate-in slide-in-from-bottom-4 duration-500"
      data-testid="cookie-banner"
      role="dialog"
      aria-labelledby="cookie-banner-title"
    >
      <div className="bg-white border border-slate-200 rounded-2xl shadow-xl p-5">
        <div className="flex items-start gap-3">
          <div className="w-9 h-9 rounded-full bg-[#DBEAFE] grid place-items-center flex-shrink-0">
            <Cookie size={18} weight="fill" className="text-[#002FA7]" />
          </div>
          <div className="flex-1 min-w-0">
            <div id="cookie-banner-title" className="font-display font-bold text-slate-900">{t("cookie.title")}</div>
            <p className="text-sm text-slate-600 mt-1 leading-relaxed">
              {t("cookie.body")}{" "}
              <Link to="/privacy" className="text-[#002FA7] underline hover:no-underline">
                {t("cookie.learn_more")}
              </Link>
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
              <button
                onClick={() => persist("all")}
                className="btn-primary !py-2 text-sm"
                data-testid="cookie-accept"
              >
                {t("cookie.accept")}
              </button>
              <button
                onClick={() => persist("essential")}
                className="btn-secondary !py-2 text-sm"
                data-testid="cookie-essential"
              >
                {t("cookie.essential_only")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
